export enum BulkSelectionStatus {
  All = "all",
  None = "none",
  Some = "some",
}

export function getBulkSelectionStatus(
  attributeId: UUID,
  selectedSkuAttributeIds: readonly (readonly UUID[])[],
): BulkSelectionStatus {
  if (!selectedSkuAttributeIds.length) return BulkSelectionStatus.None;

  const numAssigned = selectedSkuAttributeIds.reduce(
    (acc, attributeIds) => (attributeIds.includes(attributeId) ? acc + 1 : acc),
    0,
  );

  if (numAssigned === 0) return BulkSelectionStatus.None;
  if (numAssigned === selectedSkuAttributeIds.length) {
    return BulkSelectionStatus.All;
  }
  return BulkSelectionStatus.Some;
}

export function getUpdatedAttributeIds(
  currentAttributeIds: readonly UUID[],
  attributeId: UUID,
  isAssigned: boolean,
): UUID[] {
  if (isAssigned) {
    if (currentAttributeIds.includes(attributeId)) {
      return [...currentAttributeIds];
    }
    return [...currentAttributeIds, attributeId];
  }

  return currentAttributeIds.filter((id) => id !== attributeId);
}

export function applyBulkChangesToAttributeIds(
  currentAttributeIds: readonly UUID[],
  changesByAttributeId: Readonly<Record<string, boolean>>,
): UUID[] {
  const current = new Set(currentAttributeIds);

  Object.entries(changesByAttributeId).forEach(([attributeId, isAssigned]) => {
    if (isAssigned) {
      current.add(attributeId);
      return;
    }

    current.delete(attributeId);
  });

  return Array.from(current);
}

export function getIsDifferentAttributeSet(
  left: readonly UUID[],
  right: readonly UUID[],
): boolean {
  if (left.length !== right.length) return true;

  const leftSet = new Set(left);

  return right.some((id) => !leftSet.has(id));
}
